import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { ApiService } from './api.service';
import { environment } from "src/environments/environment";

@Injectable()
export class MapCommonFunctionService {
    apiKey = `${environment.HereApiKey}`;
    //baseUrl = 'https://autocomplete.geocoder.api.here.com/6.2/suggest.json?app_id=8juRomaVihyxt1ygirb2&app_code=cXefpKlLMVLM48kWl-gLfA&maxresults=5&query=';
    // autocompleteUrl = 'https://autocomplete.geocoder.ls.hereapi.com/6.2/suggest.json?apiKey=' + this.apiKey + '&beginHighlight=<b>&endHighlight=</b>&maxresults=5&query='; // HERE API v6.2
  autocompleteUrl = 'https://autosuggest.search.hereapi.com/v1/autosuggest?apiKey=' + this.apiKey + '&q=&limit=5';

  // locationDetailsUrl = 'https://geocoder.ls.hereapi.com/6.2/geocode.json?apiKey=' + this.apiKey + '&locationid=';    // HERE API v6.2
  locationDetailsUrl = 'https://lookup.search.hereapi.com/v1/lookup?apiKey=' + this.apiKey + '&id=';


  public hereLocationValuesChanged: Subject<Object> = new Subject();
    public hereLocationValuesChanged$ = this.hereLocationValuesChanged.asObservable();

    constructor(private api: ApiService) {
    }

    // addressSearch(searchText): Observable<any> {
    //      return this.api.getExternal(this.autocompleteUrl + searchText)
    // }

    // addressSearch(searchText): Observable<any> {
    //   const searchUrl = this.autocompleteUrl + encodeURIComponent(searchText); // Ensure the searchText is properly URL-encoded
    //   return this.api.getExternal(searchUrl);
    // }

    // addressSearch(searchText: string): Observable<any> {
    //   const at = '59.3786,12.7277'; // Coordinates for Klässbol
    //   const encodedSearchText = encodeURIComponent(searchText); // Encode user input
    //   const requestUrl = `https://autosuggest.search.hereapi.com/v1/autosuggest?apiKey=${this.apiKey}&q=${encodedSearchText}&limit=5`;
    //   return this.api.getExternal(requestUrl);
    // }

    addressSearch(searchText: string): Observable<any> {
      const at = '59.3786,12.7277'; // Coordinates for Klässbol
      const encodedSearchText = encodeURIComponent(searchText); // Encode user input
      const requestUrl = `https://autosuggest.search.hereapi.com/v1/autosuggest?apiKey=${this.apiKey}&q=${encodedSearchText}&at=${at}&limit=5`;
      return this.api.getExternal(requestUrl);
    }

  // locationDetails(locationId): Observable<any> {
    //     return this.api.getExternal(this.locationDetailsUrl + locationId);
    // }

    locationDetails(locationId): Observable<any> {
      const detailsUrl = this.locationDetailsUrl + encodeURIComponent(locationId);
      return this.api.getExternal(detailsUrl);
    }


}
